import { en_US } from "./en_US.mjs.mjs";
import { de_DE } from "./de_DE.mjs.mjs";
export { LocaleProvider, useLocale } from "./LocaleProvider.mjs.mjs";
export const Locales = {
    en_US,
    de_DE,
};
//# sourceMappingURL=index.mjs.mjs.map